import initI18n from './i18n';
import { registerProgramOutputSchemas } from './shared/programOutputSchemas';

/** Registers the program i18n namespace and output schemas. */
export default function init(): void {
  initI18n();
  registerProgramOutputSchemas();
}
